var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBadgeError = function SvgBadgeError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11Z",
    fill: "#EF3B39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49529 6.87305C5.82216 6.87305 6.00171 6.67048 6.01092 6.3344L6.07077 2.9322C6.07077 2.89997 6.07537 2.86775 6.07537 2.84473C6.07537 2.48563 5.84518 2.26465 5.4999 2.26465C5.15461 2.26465 4.91982 2.48563 4.91982 2.84473C4.91982 2.86775 4.92442 2.89997 4.92442 2.9322L4.98427 6.3344C4.99348 6.67048 5.16842 6.87305 5.49529 6.87305ZM5.49529 9.09208C5.8728 9.09208 6.16745 8.80204 6.16745 8.43834C6.16745 8.07464 5.8728 7.7892 5.49529 7.7892C5.12238 7.7892 4.82774 8.07464 4.82774 8.43834C4.82774 8.80204 5.12238 9.09208 5.49529 9.09208Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBadgeError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/badge-error.65697406.svg";
export { ForwardRef as ReactComponent };